import React from 'react';
import {
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import messages from './messages';

const AddKnowledgeMapButton = (props) => (
  <Button primary {...props}>
    <MaterialIcon left id="add" />
    {intl.formatMessage(messages.knowledgeMap)}
  </Button>
);

export default AddKnowledgeMapButton;
